import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meter.reducer';

export const MeterDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const meterEntity = useAppSelector(state => state.meter.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="meterDetailsHeading">
          <Translate contentKey="crawlerBackendApp.meter.detail.title">Meter</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{meterEntity.id}</dd>
          <dt>
            <span id="balanceSupplierCompanyId">
              <Translate contentKey="crawlerBackendApp.meter.balanceSupplierCompanyId">
                Balance Supplier Company Id
              </Translate>
            </span>
          </dt>
          <dd>{meterEntity.balanceSupplierCompanyId}</dd>
          <dt>
            <span id="balanceResponsibleCompanyId">
              <Translate contentKey="crawlerBackendApp.meter.balanceResponsibleCompanyId">
                Balance Responsible Company Id
              </Translate>
            </span>
          </dt>
          <dd>{meterEntity.balanceResponsibleCompanyId}</dd>
          <dt>
            <span id="meteringResponsibleCompanyId">
              <Translate contentKey="crawlerBackendApp.meter.meteringResponsibleCompanyId">
                Metering Responsible Company Id
              </Translate>
            </span>
          </dt>
          <dd>{meterEntity.meteringResponsibleCompanyId}</dd>
          <dt>
            <span id="technicalCommunicationSM">
              <Translate contentKey="crawlerBackendApp.meter.technicalCommunicationSM">
                Technical Communication SM
              </Translate>
            </span>
          </dt>
          <dd>{meterEntity.technicalCommunicationSM}</dd>
          <dt>
            <span id="allocationMethod">
              <Translate contentKey="crawlerBackendApp.meter.allocationMethod">Allocation Method</Translate>
            </span>
          </dt>
          <dd>{meterEntity.allocationMethod}</dd>
          <dt>
            <span id="contractedCapacity">
              <Translate contentKey="crawlerBackendApp.meter.contractedCapacity">Contracted Capacity</Translate>
            </span>
          </dt>
          <dd>{meterEntity.contractedCapacity}</dd>
          <dt>
            <span id="energyDeliveryStatus">
              <Translate contentKey="crawlerBackendApp.meter.energyDeliveryStatus">Energy Delivery Status</Translate>
            </span>
          </dt>
          <dd>{meterEntity.energyDeliveryStatus}</dd>
          <dt>
            <span id="invoiceMonth">
              <Translate contentKey="crawlerBackendApp.meter.invoiceMonth">Invoice Month</Translate>
            </span>
          </dt>
          <dd>{meterEntity.invoiceMonth}</dd>
          <dt>
            <span id="maxConsumption">
              <Translate contentKey="crawlerBackendApp.meter.maxConsumption">Max Consumption</Translate>
            </span>
          </dt>
          <dd>{meterEntity.maxConsumption}</dd>
          <dt>
            <span id="physicalCapacity">
              <Translate contentKey="crawlerBackendApp.meter.physicalCapacity">Physical Capacity</Translate>
            </span>
          </dt>
          <dd>{meterEntity.physicalCapacity}</dd>
          <dt>
            <span id="isSmartMeterTurnedOn">
              <Translate contentKey="crawlerBackendApp.meter.isSmartMeterTurnedOn">Is Smart Meter Turned On</Translate>
            </span>
          </dt>
          <dd>{meterEntity.isSmartMeterTurnedOn ? 'true' : 'false'}</dd>
          <dt>
            <span id="standaardJaarAfname">
              <Translate contentKey="crawlerBackendApp.meter.standaardJaarAfname">Standaard Jaar Afname</Translate>
            </span>
          </dt>
          <dd>{meterEntity.standaardJaarAfname}</dd>
          <dt>
            <span id="standaardJaarInvoeding">
              <Translate contentKey="crawlerBackendApp.meter.standaardJaarInvoeding">
                Standaard Jaar Invoeding
              </Translate>
            </span>
          </dt>
          <dd>{meterEntity.standaardJaarInvoeding}</dd>
          <dt>
            <span id="isSpecialMeteringPoint">
              <Translate contentKey="crawlerBackendApp.meter.isSpecialMeteringPoint">
                Is Special Metering Point
              </Translate>
            </span>
          </dt>
          <dd>{meterEntity.isSpecialMeteringPoint ? 'true' : 'false'}</dd>
          <dt>
            <span id="isDoubleMeter">
              <Translate contentKey="crawlerBackendApp.meter.isDoubleMeter">Is Double Meter</Translate>
            </span>
          </dt>
          <dd>{meterEntity.isDoubleMeter ? 'true' : 'false'}</dd>
          <dt>
            <span id="transactionDossierNumber">
              <Translate contentKey="crawlerBackendApp.meter.transactionDossierNumber">
                Transaction Dossier Number
              </Translate>
            </span>
          </dt>
          <dd>{meterEntity.transactionDossierNumber}</dd>
          <dt>
            <span id="reference">
              <Translate contentKey="crawlerBackendApp.meter.reference">Reference</Translate>
            </span>
          </dt>
          <dd>{meterEntity.reference}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="crawlerBackendApp.meter.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            {meterEntity.startDate ? (
              <TextFormat value={meterEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="crawlerBackendApp.meter.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {meterEntity.endDate ? (
              <TextFormat value={meterEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="productType">
              <Translate contentKey="crawlerBackendApp.meter.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{meterEntity.productType}</dd>
          <dt>
            <span id="meteringPeriod">
              <Translate contentKey="crawlerBackendApp.meter.meteringPeriod">Metering Period</Translate>
            </span>
          </dt>
          <dd>{meterEntity.meteringPeriod}</dd>
          <dt>
            <span id="feedType">
              <Translate contentKey="crawlerBackendApp.meter.feedType">Feed Type</Translate>
            </span>
          </dt>
          <dd>{meterEntity.feedType}</dd>
          <dt>
            <span id="profileCategory">
              <Translate contentKey="crawlerBackendApp.meter.profileCategory">Profile Category</Translate>
            </span>
          </dt>
          <dd>{meterEntity.profileCategory}</dd>
          <dt>
            <span id="capacityTariffCode">
              <Translate contentKey="crawlerBackendApp.meter.capacityTariffCode">Capacity Tariff Code</Translate>
            </span>
          </dt>
          <dd>{meterEntity.capacityTariffCode}</dd>
          <dt>
            <span id="physicalStatus">
              <Translate contentKey="crawlerBackendApp.meter.physicalStatus">Physical Status</Translate>
            </span>
          </dt>
          <dd>{meterEntity.physicalStatus}</dd>
          <dt>
            <span id="usageSegment">
              <Translate contentKey="crawlerBackendApp.meter.usageSegment">Usage Segment</Translate>
            </span>
          </dt>
          <dd>{meterEntity.usageSegment}</dd>
          <dt>
            <span id="locationDescription">
              <Translate contentKey="crawlerBackendApp.meter.locationDescription">Location Description</Translate>
            </span>
          </dt>
          <dd>{meterEntity.locationDescription}</dd>
          <dt>
            <span id="meterNumber">
              <Translate contentKey="crawlerBackendApp.meter.meterNumber">Meter Number</Translate>
            </span>
          </dt>
          <dd>{meterEntity.meterNumber}</dd>
          <dt>
            <span id="meterType">
              <Translate contentKey="crawlerBackendApp.meter.meterType">Meter Type</Translate>
            </span>
          </dt>
          <dd>{meterEntity.meterType}</dd>
          <dt>
            <span id="administrativeStatus">
              <Translate contentKey="crawlerBackendApp.meter.administrativeStatus">Administrative Status</Translate>
            </span>
          </dt>
          <dd>{meterEntity.administrativeStatus}</dd>
          <dt>
            <span id="smartMeterReadability">
              <Translate contentKey="crawlerBackendApp.meter.smartMeterReadability">Smart Meter Readability</Translate>
            </span>
          </dt>
          <dd>{meterEntity.smartMeterReadability}</dd>
          <dt>
            <span id="temperatureCorrection">
              <Translate contentKey="crawlerBackendApp.meter.temperatureCorrection">Temperature Correction</Translate>
            </span>
          </dt>
          <dd>{meterEntity.temperatureCorrection}</dd>
          <dt>
            <span id="numberOfCounters">
              <Translate contentKey="crawlerBackendApp.meter.numberOfCounters">Number Of Counters</Translate>
            </span>
          </dt>
          <dd>{meterEntity.numberOfCounters}</dd>
          <dt>
            <span id="counterIndication">
              <Translate contentKey="crawlerBackendApp.meter.counterIndication">Counter Indication</Translate>
            </span>
          </dt>
          <dd>{meterEntity.counterIndication}</dd>
          <dt>
            <span id="tariffZone">
              <Translate contentKey="crawlerBackendApp.meter.tariffZone">Tariff Zone</Translate>
            </span>
          </dt>
          <dd>{meterEntity.tariffZone}</dd>
          <dt>
            <span id="meteringDirection">
              <Translate contentKey="crawlerBackendApp.meter.meteringDirection">Metering Direction</Translate>
            </span>
          </dt>
          <dd>{meterEntity.meteringDirection}</dd>
          <dt>
            <span id="countingWheels">
              <Translate contentKey="crawlerBackendApp.meter.countingWheels">Counting Wheels</Translate>
            </span>
          </dt>
          <dd>{meterEntity.countingWheels}</dd>
          <dt>
            <span id="multiplicationFactor">
              <Translate contentKey="crawlerBackendApp.meter.multiplicationFactor">Multiplication Factor</Translate>
            </span>
          </dt>
          <dd>{meterEntity.multiplicationFactor}</dd>
          <dt>
            <span id="initialStartDate">
              <Translate contentKey="crawlerBackendApp.meter.initialStartDate">Initial Start Date</Translate>
            </span>
          </dt>
          <dd>
            {meterEntity.initialStartDate ? (
              <TextFormat value={meterEntity.initialStartDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.meter.meterAddress">Meter Address</Translate>
          </dt>
          <dd>{meterEntity.meterAddress ? meterEntity.meterAddress.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.meter.ean">Ean</Translate>
          </dt>
          <dd>{meterEntity.ean ? meterEntity.ean.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/meter" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meter/${meterEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MeterDetail;
